import Contract from '@/services/contract'
import { claimerAbi, nftAbi, factoryAbi } from '@/assets/abis'
import { useWalletStore } from '@/store'

const addresses = {
  NFT: '0x58D6DC909955Dca360d681D9f829Af83d23e2221',
  FACTORY: '0xcB06d94E5E46e093C3e7ce0ED3f5Ba518B29C273',
  CLAIMER: '0x99540D001e29CbFa380632B5b7C25511c8591A51',
  FFT: '0x295B5CB410773d59854a406f3538C3071461DD9F',
  NFCHEESE: '0xe4CB2c1A0400597011468862087B59fad6E134DE',
}

export async function mint(count) {
  const walletStore = useWalletStore()

  const factoryContract = new Contract(addresses.FACTORY, factoryAbi)
  const toAddress = walletStore.address
  const mintPrice = await getMintPrice(count)

  await factoryContract.send('mint', [toAddress, count], mintPrice)
}

export async function claimFotFft(fftTokenId) {
  const claimerContract = new Contract(addresses.CLAIMER, claimerAbi)
  await claimerContract.send('claimFft', [fftTokenId])
}

export async function claimForNfcheese(nfcheeseTokenId) {
  const claimerContract = new Contract(addresses.CLAIMER, claimerAbi)
  await claimerContract.send('claimNfCheese', [nfcheeseTokenId])
}

export async function getMintPrice(count) {
  const factoryContract = new Contract(addresses.FACTORY, factoryAbi)
  const price = await factoryContract.call('price')

  return Number(count) * Number(price)
}

export async function getBalance(isFft) {
  const walletStore = useWalletStore()
  const address = walletStore.address

  const contract = new Contract(
    isFft ? addresses.FFT : addresses.NFCHEESE, nftAbi)

  const [inEvents, outEvents] = await Promise.all([
    contract.getPastEvents('Transfer', { fromBlock: 0, toBlock: 'latest', filter: { to: address }}),
    contract.getPastEvents('Transfer', { fromBlock: 0, toBlock: 'latest', filter: { from: address }}),
  ])

  const inBlocks = {}
  const outBlocks = {}
  const tokenIds = []

  for (let event of inEvents) {
    inBlocks[event.returnValues?.tokenId] = event.blockNumber
  }

  for (let event of outEvents) {
    outBlocks[event.returnValues?.tokenId] = event.blockNumber
  }

  for (let [tokenId, inBlockNumber] of Object.entries(inBlocks)) {
    const outBlockNumber = outBlocks[tokenId]

    if (!outBlockNumber) {
      tokenIds.push(tokenId)
      continue
    }

    if (inBlockNumber > outBlockNumber) {
      tokenIds.push(tokenId)
    }
  }

  const promises = []

  const init = async (tokenId) => {
    const claimerContract = new Contract(addresses.CLAIMER, claimerAbi)
    const isClaimed = await claimerContract.call(isFft ? 'fftClaimed' : 'nfCheeseClaimed', [tokenId])

    return {
      edition: tokenId,
      isClaimed,
    }
  }

  for (let tokenId of tokenIds) {
    promises.push(init(tokenId))
  }

  return await Promise.all(promises)
}

export function removeDecimals(value) {
  return Number(value) / Math.pow(10, 18)
}